<template>
<div class="footer" style="width:100%;">
  <querytitle>
    <template slot="queryleft">
      <div>
        <span style="color: #000">要求完成时间：</span><span style="color: red">{{ SFT.PDATE }}</span>
      </div>
      <div v-if="SFT.SDATE">
        <span style="color: #000">实际完成时间：</span><span style="color: red">{{ SFT.SDATE }}</span>
      </div>
      <div v-else>
        <el-tag type="success" v-if="td.td>0">还有{{td.dd}}天{{td.hh}}小时</el-tag>
        <el-tag type="danger" v-else>已过期{{Math.abs(td.dd)}}天,请赶快完成任务！</el-tag>
      </div>
    </template>
    <template slot="queryright">
      <el-button type="primary" size="small" @click="sftsumit()">已完成，提交此任务</el-button>
    </template>
  </querytitle>
</div>
</template>

<script>
import querytitle from "@/components/querytitle";
export default {
  components: {
    querytitle
  },
  props: {
    SFT: {
      type: Object,
      default: {
        TID: "",
        PDATE: "",
        SDATE: ""
      },
    },
    chkdata: {
      //判断是否可以提交
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      td: {}
    }
  },
  watch: {
    'SFT'(to, from) {
      this.td = this.TimeDiff(this.SFT.PDATE, this.SFT.SDATE)
      this.gettasksitem()
    }
  },
  mounted() {
    this.td = this.TimeDiff(this.SFT.PDATE, this.SFT.SDATE)
    this.gettasksitem()
  },
  methods: {
    gettasksitem() {
      let that = this
      let pars = {
        objname: "sys_tasksitem",
        wheres: [{
          field: "TID",
          sym: "=",
          val: that.SFT.TID,
          oper: "and"
        }, {
          field: "YY",
          sym: "=",
          val: that.SFT.YY,
          oper: "and"
        }],
      };
      switch (this.CU.cu.uclass) {
        case "导师":
          pars.wheres.push({
            field: "STID",
            sym: "=",
            val: that.CU.cu.uid,
            oper: "and"
          })
          break;
        case "学生":
          pars.wheres.push({
            field: "SSID",
            sym: "=",
            val: that.CU.cu.uid,
            oper: "and"
          })
          break;
        default:
          pars.wheres.push({
            field: "SID",
            sym: "=",
            val: that.CU.cu.sid,
            oper: "and"
          })
          break;
      }
      that.PostData(
        "Common/GETLIST",
        pars,
        function (res) {
          if (res.data.data.length > 0)
            that.SFT.SDATE = res.data.data[0].SDATE
          else
            that.SFT.SDATE = ""
        },
        function (err) {
          that.$alert(err, {
            title: "错误"
          });
        }
      );
    },
    sftsumit() {
      let that = this;
      this.chkdata(
        function (res) {
          that.$confirm("确定提交当前[" + that.SFT.TNAME + "]任务吗?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              that.savesdate();
            }).catch(() => {
              that.$message({
                type: "info",
                message: "已取消提交",
              });
            });
        },
        function (err) {
          that.$alert(err, {
            type: 'error',
            title: "错误"
          });
        }
      )
    },
    savesdate() {
      let that = this;
      let sdate = that.FormatDate(new Date())
      let pars = {
        TID: that.SFT.TID,
        YY: that.SFT.YY,
        SID: that.CU.cu.sid
      };
      switch (this.CU.cu.uclass) {
        case "导师":
          pars.STID = that.CU.cu.uid;
          break;
        case "学生":
          pars.SSID = that.CU.cu.uid;
          break;
        case "专家":
          pars.STID = that.CU.cu.uid;
          break;
        default:
          pars.SID = that.CU.cu.sid;
          break;
      }

      that.$prompt('请输入说明', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: "text",
        inputPlaceholder: "输入说明文字"
      }).then((value) => {
        pars.TIDESC = value.value
        console.log(pars)
        that.PostData(
          "Common/GetOtherMethod", {
            methodname: "SubmitTask",
            pars: pars,
          },
          function (res) {
            console.log(res)
            if (res.data.error_code != 0) {
              that.$alert(res.data.message, {
                title: "错误"
              });
              return;
            }
            that.SFT.SDATE = sdate
          },
          function (err) {
            console.log(err);
          }
        );
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
  },
};
</script>

<style>
.footer {
  border-top: 1px solid #ebeef5;
  padding: 5px;
  /* background-color: bisque; */
}
</style>
